export default __webpack_public_path__ + "static/media/IPC-background.a8b4f9ad.jpeg";